import { forwardRef, HTMLAttributes } from "react"
import cn from "classnames"

import style from "modules/Call/components/SafetyPopover/Shield/style.module.scss"
import { Icon } from "components"
import { TextWithIcon } from "ui-kit/components-branded/index"

export const Shield = forwardRef<
    HTMLDivElement,
    HTMLAttributes<HTMLDivElement> & { iconClassName?: string } & { isAccent?: boolean }
>(({ children, className, iconClassName, isAccent, ...props }, ref) => (
    <div {...props} ref={ref}>
        <TextWithIcon
            className={className}
            icon={<Icon className={cn(style.shield, iconClassName)} type="shield-done" size={24} />}
            position="left"
            isAccent={isAccent}
        >
            {children}
        </TextWithIcon>
    </div>
))

Shield.displayName = "Shield"
